import React from "react";
import PropTypes from "prop-types";

const FormHeader = ({
  logo,
  companyName,
  title1,
  title2,
  title3,
  docNo,
  revNo,
  date
}) => {

  const cellStyle = {
    border: "1px solid black",
    padding: "8px"
  };

  return (
    <table
      width="100%"
      style={{ borderCollapse: "collapse", border: "1px solid black" }}
    >
      <tbody>
        <tr>
          <td rowSpan="3" width="120" align="center" style={cellStyle}>
            <img src={logo} alt="logo" width="80" />
          </td>

          <td rowSpan="3" align="center" style={cellStyle}>
            <strong>{companyName}</strong>
            <br />
            {title1}
            <br />
            <b>{title2}</b>
            <br />
            <b>{title3}</b>
          </td>

          <td width="250" style={cellStyle}>
            <b>DOC NO:</b> {docNo}
          </td>
        </tr>

        <tr>
          <td style={cellStyle}>
            <b>REV NO:</b> {revNo}
          </td>
        </tr>

        <tr>
          <td style={cellStyle}>
            <b>REV DATE:</b> {date}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

FormHeader.propTypes = {
  logo: PropTypes.string,
  companyName: PropTypes.string,
  title1: PropTypes.string,
  title2: PropTypes.string,
  title3: PropTypes.string,
  docNo: PropTypes.string,
  revNo: PropTypes.string,
  date: PropTypes.string
};

export default FormHeader;